<div class="mobile-offer-details">
  <app-product [productData]="cardData"></app-product>
  <app-conditions [conditionsData]="cardData"></app-conditions>
  <app-proof [proofData]="cardData"></app-proof>

  <!-- Customer Ratings Section -->
  <div *ngIf="hasCustomerRatings" class="mobile-offer-details__ratings">
    <app-customer-ratings
      [productId]="cardData.bankProduct.product.productDetails.productId"
      [bankName]="cardData.bankProduct.bankDetails.bankName"
    >
    </app-customer-ratings>
  </div>

  <!-- Customer Feedback Section -->
  <div *ngIf="hasCustomerRatings" class="mobile-offer-details__feedback">
    <app-customer-feedback
      [productId]="cardData.bankProduct.product.productDetails.productId"
    >
    </app-customer-feedback>
  </div>

  <div
    *ngIf="showMobInterestExplanation"
    class="mobile-offer-details__explanation"
  >
    {{ interestExplanationHintText }}
  </div>
</div>
